import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditablePen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 3.08564L15 6.08564M10 17.0856H18M2 13.0856L1 17.0856L5 16.0856L16.586 4.49964C16.9609 4.12458 17.1716 3.61596 17.1716 3.08564C17.1716 2.55531 16.9609 2.04669 16.586 1.67164L16.414 1.49964C16.0389 1.12469 15.5303 0.914062 15 0.914062C14.4697 0.914063 13.9611 1.12469 13.586 1.49964L2 13.0856Z",
		stroke: "#FF9110",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgEditablePen);
export { ForwardRef as ReactComponent };
